"use strict";

(function(z, Backbone){

    var TariffVendorPromotionModel = Backbone.Model.extend({
        urlRoot: "/api/tariff-vendor-promotion",

        validation: {
            type: [{
                required: true,
                msg: Translator.trans("js.error_message_tariffPromotion_type_required")
            }],
            value: [
                {
                required: true,
                msg: Translator.trans("js.error_message_tariffPromotion_value_required")
                },
                {
                pattern: 'number',
                msg: Translator.trans('js.error_message_tariffPromotion_value_format')
                },
                {
                    min: 1,
                    msg: Translator.trans('js.error_message_tariffPromotion_value_format')
                }],
            dateStart: function(value) {
                if( typeof value == 'undefined' || ( typeof value !== 'undefined' && value == '')){
                    return Translator.trans("js.error_message_tariffPromotion_dateStart_required");
                }
                var dateReg = /^\d{2}([-])\d{2}\1\d{4}$/;

                if(! value.match(dateReg)){
                    var now = new Date(value);
                    var day = ("0" + now.getDate()).slice(-2);
                    var month = ("0" + (now.getMonth() + 1)).slice(-2);
                    var date = (day) +"-"+(month)+"-" + now.getFullYear();
                    if(! date.match(dateReg)){
                        return Translator.trans("js.error_message_tariffPromotion_dateStart_format");
                    }
                }
            }
            ,
            dateEnd: function(value) {
                if( typeof value == 'undefined' || ( typeof value !== 'undefined' && value == '')){
                    return Translator.trans("js.error_message_tariffPromotion_dateEnd_required");
                }
                var dateReg = /^\d{2}([-])\d{2}\1\d{4}$/;

                if(! value.match(dateReg)){
                    var now = new Date(value);
                    var day = ("0" + now.getDate()).slice(-2);
                    var month = ("0" + (now.getMonth() + 1)).slice(-2);
                    var date = (day) +"-"+(month)+"-" + now.getFullYear();
                    if(! date.match(dateReg)){
                        return Translator.trans("js.error_message_tariffPromotion_dateEnd_format");
                    }
                }
            },
        },

        /**
         * Parses the response and returns the appropriate data
         * @param {Object} response The reponse
         * @return {Object} The data
         */
        parse: function(response){

            return response.data;
        }
    });

    z.TariffVendorPromotionModel = TariffVendorPromotionModel;

})(window.z = window.z || {}, Backbone);